import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Button,
    TextField,
} from '@mui/material'
// need the circular progress for while the request is being processed
import CircularProgress from '@mui/material/CircularProgress';
import { GridStatus } from 'components/Core/Common'
import { EmailField, emailValid, AuthenticationCodeField } from 'components/Core/Fields'
import { useAuthFunctions, useAuthState } from 'contexts/Auth';

import Logo from 'media/Logo';



export default function Login(props) {
    const auth = useAuthFunctions()

    const handleFederatedLogin = React.useCallback(() => {
        auth.federatedLogin()
    }, [auth])

    React.useEffect(() => {
        console.log("loaded auth")
        auth.logSettings()

    }, [])

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
    }


    const formStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        margin: '1rem',
    }

    return (
        <>
            <Box
                style={containerStyle}
                onClick={e => e.stopPropagation()}

            >
                <Paper style={formStyle}>
                    <Logo />
                    <Typography
                        variant="h4"
                        align='center'
                        color="primary"
                    >
                        Login
                    </Typography>
                    <Button
                        style={{ width: 200, color: 'primary' }}
                        onClick={handleFederatedLogin}    
                    >
                        Login
                    </Button>

                </Paper>
            </Box>
        </>
    )
}
